import React from "react";

import { CourseDocumentForm, DocumentFormValues } from "./CourseDocumentForm";
import { courseDocumentsApi } from "api";
import { useToaster } from "utils";

interface CourseDocumentCreateProps {
  courseId: number;
  refreshList: () => void;
  onNavigateToList?: () => void;
}

export const CourseDocumentCreate = ({
  courseId,
  refreshList,
  onNavigateToList,
}: CourseDocumentCreateProps): JSX.Element => {
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: DocumentFormValues) => {
    const { templateId, name, activePage, ...formData } = data;
    const placeholders = Object.entries(formData).map(([key, value]) => ({
      placeholderId: Number(key),
      placeholderValue: value + "",
    }));
    try {
      if (!activePage) {
        throw new Error("Brak aktywnej strony szablonu");
      }
      await courseDocumentsApi.create(courseId, {
        templateId: Number(templateId),
        templatePageId: Number(activePage),
        placeholders,
        name,
      });
      showSuccess("Dodano nowy szablon dokumentu");
      onNavigateToList?.();
      refreshList();
    } catch (e) {
      showError("Nie udało się dodać nowego szablonu dokumentu");
      console.error(e);
    }
  };

  return <CourseDocumentForm onSubmit={onSubmit} courseId={courseId} />;
};
